import React, { useRef } from 'react';
import { Portal } from '@material-ui/core';
import { clsx } from '@components/Provider';
import useStyles from './useStyles';

interface Props {
  matches: boolean;
  visible: boolean;
  isChat: boolean;
  isChatOpen: boolean;
  leftComponent: React.ReactNode;
  rightComponent: React.ReactNode;
}

const DashboardPresenter = ({
  matches,
  visible,
  isChat,
  leftComponent,
  rightComponent
}: Props) => {
  const classes = useStyles();
  const divRef = useRef<HTMLDivElement>(null);

  return (
    <div className={classes['Dashboard-Root']}>
      <div tabIndex={-1} className={classes['Dashboard-Left-Root']}>
        {leftComponent}
      </div>

      {!matches && (
        <div
          id="Dashboard-Right-Root"
          ref={divRef}
          className={clsx(classes['Dashboard-Right-Root'])}
        >
          {rightComponent}
        </div>
      )}

      {matches && visible && (
        <Portal container={divRef.current}>
          <div
            className={clsx(classes['Dashboard-Portal'], {
              'chat': isChat
            })}
          >
            {rightComponent}
          </div>
        </Portal>
      )}
    </div>
  );
};

export default DashboardPresenter;
